<div class="crack-view-wrapper">
  <div style="margin-left: 39%;" *ngIf="loading">
    <mat-spinner> </mat-spinner>
  </div>
  <div class="top-controls">
    <div class="column-toggle">
      <span class="month-label">Display Columns:</span>
      <mat-checkbox color="primary" [(ngModel)]="showCracks" (change)="savePreferences(false)">
        Cracks
      </mat-checkbox>
      <mat-checkbox color="primary" [(ngModel)]="showLength" (change)="savePreferences(false)">
        Length
      </mat-checkbox>
      <mat-checkbox color="primary" [(ngModel)]="showRecracks" (change)="savePreferences(false)">
        Recracks
      </mat-checkbox>
    </div>
    <div class="month-selector">
      <span class="month-label">{{'Select Months '| translate | async}}:</span>
      <mat-radio-group [(ngModel)]="selectedMonths" name="CrackMonths" (change)="savePreferences(true)"
        class="month-radio-group">
        <mat-radio-button [value]="3">3 Months</mat-radio-button>
        <mat-radio-button [value]="6">6 Months</mat-radio-button>
        <mat-radio-button [value]="12">12 Months</mat-radio-button>
      </mat-radio-group>
    </div>
    <a class="button button--primary" (click)="!excelDownload && exportExcelFromAPI()" [class.loading]="excelDownload"
      [class.disabled]="excelDownload">
      <span class="button__text align-btn">
        <mat-icon *ngIf="excelDownload" class="spin">autorenew</mat-icon>
        <mat-icon *ngIf="!excelDownload">save_alt</mat-icon>
        {{ excelDownload ? 'Exporting...' : ('Export to Excel' | translate | async) }}
      </span>
    </a>
  </div>
  <div class="top-scroll" #topScroll>
    <div class="scroll-inner" [style.width.px]="tableWidth"></div>
  </div>
  <div class="dashboard-wrapper" #tableScroll>
    <table class="data-table" [ngClass]="getMonthClass()" #dataTable>
      <thead>
        <tr class="sticky-row-1">
          <th class="sticky-col col-1"></th>
          <th class="sticky-col col-2">Family</th>
          <th class="sticky-col col-3">Model</th>
          <th class="sticky-col col-4">UnitNo</th>
          <th *ngFor="let m of months" [attr.colspan]="getVisibleColumnCount()">
            {{ m.MonthName }}
          </th>
        </tr>

        <tr class="sticky-row-2" *ngIf="groupedData?.length > 0">
          <th class="sticky-col col-1"></th>
          <th class="sticky-col col-2"></th>
          <th class="sticky-col col-3"></th>
          <th class="sticky-col col-4"></th>

          <ng-container *ngFor="let m of months">
            <th *ngIf="showCracks">Cracks</th>
            <th *ngIf="showLength">Length ({{userUOM}})</th>
            <th *ngIf="showRecracks">Recracks</th>
          </ng-container>
        </tr>
        <tr class="sticky-row-3 total-row" *ngIf="groupedData?.length > 0">
          <th class="sticky-col col-1"></th>
          <th class="sticky-col col-2"></th>
          <th class="sticky-col col-3"></th>
          <th class="sticky-col col-4">Total</th>

          <ng-container *ngFor="let m of monthTotals">
            <th *ngIf="showCracks">
              {{ m.TotalCracks || '' }}
            </th>
            <th *ngIf="showLength">
              {{ formatLength(m.TotalLength) }}
            </th>
            <th *ngIf="showRecracks">
              {{ m.TotalRecracks || '' }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let row of groupedData">
          <tr>
            <td class="sticky-col col-1">
              <div class="click-wrapper" (click)="toggleUnit(row)">
                <span class="toggle-icon">{{ row.expanded ? '−' : '+' }}</span>
              </div>
            </td>

            <td class="sticky-col col-2">{{ row.Family }}</td>
            <td class="sticky-col col-3">{{ row.Model }}</td>
            <td class="sticky-col col-4">
              <a (click)="openInNewTab(row.GETId)" style="cursor: pointer;">
                {{ row.UnitNo }}
              </a>
            </td>
            <ng-container *ngFor="let m of months; let i = index">
              <td *ngIf="showCracks">{{ row.Months[i]?.TotalCracks || '' }}</td>
              <!-- <td *ngIf="showLength">{{ row.Months[i]?.TotalLength || '' }}</td> -->
              <td [class.hidden-col]="!showLength">{{ formatLength(row.Months[i]?.TotalLength) }}</td>
              <td *ngIf="showRecracks">{{ row.Months[i]?.TotalRecracks || '' }}</td>
            </ng-container>
          </tr>
          <ng-container *ngIf="row.expanded">

            <ng-container *ngFor="let ct of row.componentTypes">

              <tr class="level2-row">
                <td class="sticky-col col-1">
                  <div class="click-wrapper" (click)="toggleComponentType(row, ct)">
                    <span class="toggle-icon">{{ ct.expanded ? '−' : '+' }}</span>
                  </div>
                </td>

                <td class="sticky-col col-2"></td>
                <td class="sticky-col col-3"></td>
                <td class="sticky-col col-4">
                  {{ ct.ComponentTypeName }}
                </td>

                <ng-container *ngFor="let m of months; let i = index">
                  <td *ngIf="showCracks">{{ ct.Months[i]?.TotalCracks || '' }}</td>
                  <!-- <td *ngIf="showLength">{{ ct.Months[i]?.TotalLength || '' }}</td> -->
                  <td [class.hidden-col]="!showLength">{{ formatLength(ct.Months[i]?.TotalLength) }}</td>
                  <td *ngIf="showRecracks">{{ ct.Months[i]?.TotalRecracks || '' }}</td>
                </ng-container>
              </tr>
              <ng-container *ngIf="ct.expanded">

                <tr *ngFor="let comp of ct.components; trackBy: trackByIndex" class="level3-row">
                  <td class="sticky-col col-1"></td>
                  <td class="sticky-col col-2"></td>
                  <td class="sticky-col col-3"></td>
                  <td class="sticky-col col-4 level3-indent">
                    {{ comp.ComponentName }}
                  </td>
                  <ng-container *ngFor="let m of months; let i = index">
                    <td *ngIf="showCracks">{{ comp.Months[i]?.TotalCracks || '' }}</td>
                    <td [class.hidden-col]="!showLength">{{ formatLength(comp.Months[i]?.TotalLength) }}</td>
                    <td *ngIf="showRecracks">{{ comp.Months[i]?.TotalRecracks || '' }}</td>
                  </ng-container>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>